import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { api } from '../api';
import { useTallerDeLaCache } from '../taller/ProveedorTaller';

// La moneda del taller, para mostrar precios (#112).
//
// Sale del ajuste `currency_code` por `GET /api/me/settings`, y no del idioma:
// `dinero()` de `@tallerya/i18n` la exige justamente por eso —alguien con el
// navegador en inglés puede estar cobrando en lempiras—.
//
// Mientras carga es `undefined`, y quien la usa muestra el número sin símbolo en
// vez de suponer una: un precio con la moneda equivocada es peor que uno sin
// moneda durante un instante.
//
// La clave lleva el taller (regla 5), y no se vuelve a pedir en la sesión: la
// moneda de un taller es `readonly` y no cambia mientras alguien trabaja.

const MONEDA = 'currency_code';

export function useMoneda(): string | undefined {
  const auth = useAuth();
  const taller = useTallerDeLaCache();

  const consulta = useQuery({
    queryKey: ['ajustes', taller],
    enabled: auth.isAuthenticated,
    queryFn: async () => {
      const { data, error } = await api.GET('/api/me/settings');
      if (error || !data) throw new Error('No se pudo leer la configuración del taller');
      return data.settings;
    },
    staleTime: Infinity,
  });

  return consulta.data?.find((a) => a.code === MONEDA)?.value ?? undefined;
}
